<template>
  <NuxtImg
    src="/plane.svg"
    class="size-32 animate-spin"
  />
</template>
